import { LAB_DEEP_VIEW_ANCHOR, LAB_PATENT_COLOR_ANCHOR, LAB_PATENT_WORD_CLOUD_ANCHOR, LAB_WORKSPACE_LITE_TABLE_ANCHOR, LAB_HI_RES_IMAGE_ANCHOR } from '@cores/constants/envConfig';
import { E_LABS_NAME } from './enums';
export const LABS_NAME_KEY_MAPPING = {
    [E_LABS_NAME.PATENT_COLOR]: LAB_PATENT_COLOR_ANCHOR,
    [E_LABS_NAME.PATENT_WORD_CLOUD]: LAB_PATENT_WORD_CLOUD_ANCHOR,
    [E_LABS_NAME.WORKSPACE_LITE_TABLE]: LAB_WORKSPACE_LITE_TABLE_ANCHOR,
    [E_LABS_NAME.DEEP_VIEW]: LAB_DEEP_VIEW_ANCHOR,
    [E_LABS_NAME.HI_RES_IMAGE]: LAB_HI_RES_IMAGE_ANCHOR,
};
export const LABS_KEY_NAME_MAPPING = {
    [LAB_PATENT_COLOR_ANCHOR]: E_LABS_NAME.PATENT_COLOR,
    [LAB_PATENT_WORD_CLOUD_ANCHOR]: E_LABS_NAME.PATENT_WORD_CLOUD,
    [LAB_WORKSPACE_LITE_TABLE_ANCHOR]: E_LABS_NAME.WORKSPACE_LITE_TABLE,
    [LAB_DEEP_VIEW_ANCHOR]: E_LABS_NAME.DEEP_VIEW,
    [LAB_HI_RES_IMAGE_ANCHOR]: E_LABS_NAME.HI_RES_IMAGE,
};
